import React from 'react';
import dynamic from 'next/dynamic';
import { useFathom } from '@src/lib/hooks/useFathom';

const TeaserPromotion = dynamic(() =>
  import('@components/molecules/TeaserPromotion/TeaserPromotion').then((module) => module.TeaserPromotion),
);

export const PageContentElementEntityAd = (element) => {
  const fathom = useFathom();

  if (!element) return null;
  function trackClick() {
    fathom.trackEvent('Entity Ad Click');
  }
  return <TeaserPromotion {...element} onCtaClick={trackClick} />;
};

export default PageContentElementEntityAd;
